<template>
  <div class="detail-pause" v-if="info">
    <div v-if="!isInApp && !info.has_sub">
      <SubBox />
    </div>
    <div v-if="type == 4" class="pause-box">
      <img :src="cur_status ? curIcon[0] : curIcon[1]" class="cur-icon" />
      <div class="cur_text">
        <div v-if="cur_status">
          当前同时答题人数过多，请稍后再试
          <div v-if="!info.is_owner">
            或给
            <div class="inline-r">
              <span class="themeColor" @click="toDetail()">
                出题人：{{ info.owner_name }}
              </span>
              <WxLink v-if="isWeixin && isMobile" :wxPath="wxPath + qid" />
            </div>
            发送留言，提醒ta修改限制
          </div>
          <div class="backIcon">
            <button @click="backHome">回到答题主页（{{ time }}s）</button>
            <div class="position-r flex1 flex" v-if="info.is_owner">
              <button @click="toDetail()" class="priColor ml30">
                增加答题人数上限
              </button>
              <WxLink v-if="isWeixin && isMobile" :wxPath="wxPath + qid" />
            </div>
            <div class="position-r flex1 flex" v-else>
              <button @click="toDetail()" class="priColor ml30">
                去留言
              </button>
              <WxLink v-if="isWeixin && isMobile" :wxPath="wxPath + qid" />
            </div>
          </div>
        </div>
        <div v-else>
          当前同时答题人数已达上限(50人)<br />
          正在排队中，如排队时间过长请稍后再试
          <div v-if="!info.is_owner">
            或给
            <div class="inline-r">
              <span class="themeColor" @click="toDetail()">
                出题人：{{ info.owner_name }}
              </span>
              <WxLink v-if="isWeixin && isMobile" :wxPath="wxPath + qid" />
            </div>
            发送留言，提醒ta修改限制
          </div>
          <div class="backIcon">
            <button class="priColor" @click="backHome">
              离开排队，待会再来
            </button>
            <div class="position-r flex1 flex" v-if="info.is_owner">
              <button class="priColor ml30" @click="toDetail()">
                增加答题人数上限
              </button>
              <WxLink v-if="isWeixin && isMobile" :wxPath="wxPath + qid" />
            </div>
            <div class="position-r flex1 flex" v-else>
              <button class="priColor ml30" @click="toDetail()">
                去留言
              </button>
              <WxLink v-if="isWeixin && isMobile" :wxPath="wxPath + qid" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="pause-box">
      <div class="tip">
        <img
          class="tip-icon"
          src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220415/aaad6764c86d15b1d4b4074927b38d10.jpg"
        />
      </div>
      <div class="tips">
        {{
          type == 3 && info.max_join_type
            ? "今日次数已用完，明天再来吧！"
            : typeLists[type].tips
        }}
      </div>
      <!-- 已结束 -->
      <div v-if="type == 0">
        <div class="desc">
          订阅出题人接收ta新的活动通知<span class="themeColor pointer" @click="toOwnerHome()">去订阅></span>
        </div>
        <div class="btn-group">
          <button @click="toOwnerHome()">订阅出题人</button>
        </div>
      </div>
      <!-- 未开始 -->
      <div v-if="type == 1">
        <div class="desc">
          <div>答题开始时间：{{ info.startDate }}</div>
          <div>请在开始时间后进入答题</div>
        </div>
        <div class="btn-group">
          <button @click="toDetail()">订阅活动通知</button>
        </div>
      </div>
      <!-- 参与人数达到上限 | 答题次数已用完 -->
      <div v-if="type == 2 || type == 3">
        <div class="desc">
          <div v-if="type == 3 && info.temp == 2">
            点击下方设置定时提醒时间，不错过答题机会
          </div>
          <div v-else>
            {{
              type == 2
                ? "参与人数已达出题人设置的人数上限"
                : "答题次数已达出题人设置的次数上限"
            }}，如需继续参与，点击下方给
            <div class="inline-r">
              <span class="themeColor" @click="toDetail()">
                出题人: {{ info.owner_name }}
              </span>
              <WxLink v-if="isWeixin && isMobile" :wxPath="wxPath + qid" />
            </div>
            留言修改设置。
          </div>
        </div>
        <div class="btn-group" v-if="type == 3 && info.temp == 2">
          <button @click="toDetail()">接收答题提醒</button>
          <WxLink v-if="isWeixin && isMobile" :wxPath="wxPath + qid" />
        </div>
        <div class="btn-group" v-else>
          <button @click="toDetail()">去留言</button>
          <WxLink v-if="isWeixin && isMobile" :wxPath="wxPath + qid" />
        </div>
      </div>
      <!-- 答题总次数已用完 -->
      <div v-if="type == 5">
        <div class="desc">
          <div v-if="info.is_owner">
            总答题次数已达到出题人设置上限，如需继续参与，点击下方
            <div class="inline-r">
              <span class="themeColor" @click="toDetail()">
                去增加总答题次数
              </span>
              <WxLink v-if="isWeixin && isMobile" :wxPath="wxPath + qid" />
            </div>
          </div>
          <div v-else>
            总答题次数已达到出题人设置上限，如需继续参与，点击下方给
            <div class="inline-r">
              <span class="themeColor" @click="toDetail()">
                出题人: {{ info.owner_name }}
              </span>
              <WxLink v-if="isWeixin && isMobile" :wxPath="wxPath + qid" />
            </div>
            留言修改设置。
          </div>
        </div>
        <div class="btn-group" v-if="info.is_owner">
          <button @click="toDetail()">去增加</button>
          <WxLink v-if="isWeixin && isMobile" :wxPath="wxPath + qid" />
        </div>
        <div class="btn-group" v-else>
          <button @click="toDetail()">去留言</button>
          <WxLink v-if="isWeixin && isMobile" :wxPath="wxPath + qid" />
        </div>
      </div>
    </div>
    
    <ContactImg
      :visible="showContact"
      @hideVisible="handleContact()"
      src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2022-12-05/e7d0824e69a735c51a3286ccdd07612c.png"
    />
    <van-popup
      v-model="showVersionTip"
      :style="{ borderRadius: '8px', width: '320px' }"
      closeable
      close-icon="close"
      @closed="showVersionTip = false"
    >
      <div class="upgrage-wrapper">
        <div class="upgrage-title">
          H5版本暂不支持<br />
          请使用手机扫码，到小程序操作
        </div>
        <div class="other-way">
          <p><span></span><span></span><span></span></p>
          <div>其他参与方式</div>
          <p><span></span><span></span><span></span></p>
        </div>
        <div class="quesTitle lines-overflow">{{ info.title }}</div>
        <img class="quesQrcode" :src="settingSrc" alt="" />
        <div class="upgrag-tip">微信长按或扫码参与答题</div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {
  getLocalTime,
  getToken,
  reLogin,
  showServiceAble,
  isWeixin,
  isMobile,
  getWxUrl,
  getDetailWxCode,
  formatDate
} from "@/utils/common";
import questionOnly from "@/utils/questionOnly";
import ContactImg from "@/components/contactImg";
import SubBox from "@/components/subBox";
import WxLink from "@/components/wxLink.vue";

import { Toast } from "vant";

let timer;
let timerCount;
export default {
  components: { ContactImg, SubBox, WxLink },
  data() {
    return {
      delta: 1, // 1.主页 2.表单页
      isInApp: wemeet.app.isTMWebview(),
      isWeixin: isWeixin(),
      isMobile: isMobile(),
      watchAble: false,
      qid: "",
      info: null,
      cur_status: 0,
      wait_status: 0,
      type: 0,
      time: 0,
      timeCount: 180,
      time: 10,
      curIcon: [
        "https://cdn-xcx-qunsou.weiyoubot.cn/material/2022-09-23/679ad11792d0c050689ad064f355aa7e.png",
        "https://cdn-xcx-qunsou.weiyoubot.cn/material/2022-09-23/529b504d81946038e0f9c0c870bd4bd4.png"
      ],

      typeLists: [
        {
          type: 0,
          tips: "答题已到结束时间"
        },
        {
          type: 1,
          tips: "答题未开始"
        },
        {
          type: 2,
          tips: "参与人数达到上限"
        },
        {
          type: 3,
          tips: "答题次数已用完"
        },
        {
          type: 4,
          tip: "同时答题人数达到上限"
        },
        {
          type: 5,
          tips: "总答题次数达到上限"
        }
      ], // 0: 答题已结束 1: 答题未开始 2: 参与人数达到上线 3: 答题次数已用完 4: 达到同时答题人数上限 5: 达到总答题次数
      showContact: false,
      showVersionTip: false,
      settingSrc: "",
      settingUrl: "",
      ownerUrl: "",
      wxPath: "/pages/detail/detail?qid="
    };
  },
  async mounted() {
    let { qid = "", type = 0, wait_status = 0, delta = 1 } = this.$route.query;
    this.qid = qid;
    this.delta = delta;
    let res = await this.getDetail();
    if (res) {
      this.type = type;
      if (localStorage.getItem("wait" + this.qid)) {
        this.updateWait(1);
      }
      if (type == 4) {
        // wait_status  0:排队人数超出50  1: 排队人数没超过50,
        if (wait_status) {
          // 排队人数超出50
          this.cur_status = 1;
          this.countdownTime();
        } else {
          //排队人数没超过50,
          this.updateWait(0);
          this.watchAble = true;
          this.wait_status = 1;
          localStorage.setItem("wait" + this.qid, 1);
          this.countdownCount();
          this.watching();
        }
      }
    }
  },
  methods: {
    toMessage() {},
    receiveTip() {},
    async toDetail() {
      if (this.isMobile) {
        if (!this.settingUrl) {
          let res = await getWxUrl("pages/detail/detail", this.qid, 1);
          if (res) {
            this.settingUrl = res;
          }
        }
        window.location.href = this.settingUrl;
        return;
      } else {
        if (!this.settingSrc) {
          let res = await getDetailWxCode(this.qid);
          if (res) {
            this.settingSrc = res;
          }
        }
        this.showVersionTip = true;
      }
    },
    async handleContact() {
      let res = await showServiceAble();
      if (res) {
        this.showContact = !this.showContact;
      }
    },
    backHome() {
      this.$router.go(-1);
      this.cancelWatch();
    },
    cancelWatch() {
      if (timerCount) {
        clearInterval(timerCount);
        timerCount = null;
      }
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
      this.watchAble = false;
      if (this.wait_status) {
        this.wait_status = 0;
        this.updateWait(1);
      }
    },

    toEdit() {
      this.showContact = true;
    },
    async toOwnerHome() {
      if (this.isMobile) {
        if (!this.ownerUrl) {
          let res = await getWxUrl("pages/homepage/homepage", this.info.owner_unionid, 1);
          if (res) {
            this.ownerUrl = res;
          }
        }
        window.location.href = this.ownerUrl;
        return;
      } else {
        if (!this.settingSrc) {
          let res = await getDetailWxCode(this.qid);
          if (res) {
            this.settingSrc = res;
          }
        }
        this.showVersionTip = true;
      }
    },
    countdownTime() {
      // 发卷失败10s倒计时
      if (!timer) {
        timer = setInterval(() => {
          if (this.time == 0) {
            clearInterval(timer);
            timer = null;
            this.backHome();
            return;
          }
          this.time = this.time - 1;
        }, 1000);
      }
    },
    countdownCount() {
      // 排队中，轮询排队状态3分钟
      if (!timerCount) {
        timerCount = setInterval(() => {
          let isTiming = false;
          let { enable_time_range = 0, t_end = 0 } = this.info || {};
          if (enable_time_range && getLocalTime() > t_end * 1000) {
            isTiming = true;
          }
          if (this.timeCount == 1 || isTiming) {
            if (isTiming) {
              this.type = 0;
              this.cancelWatch();
            } else {
              clearInterval(timerCount);
              timerCount = null;
              this.cur_status = 1;
              this.countdownTime();
              this.watchAble = false;
              if (this.wait_status) {
                this.wait_status = 0;
                this.updateWait(1);
              }
            }
            return;
          }
          this.timeCount = this.timeCount - 1;
        }, 1000);
      }
    },
    watching() {
      if (!this.watchAble) return;
      questionOnly
        .get("/xcx/ques/v1/join/status", {
          access_token: getToken(),
          qid: this.qid
        })
        .then(res => {
          if (res.sta == 0) {
            let { curr_join_limit = 0, curr_join } = res.data || {};
            if (curr_join_limit - curr_join >= 1 || curr_join_limit == -1) {
              //有空
              this.quesStart();
            } else {
              setTimeout(() => {
                this.watching();
              }, 10000);
            }
          } else if (res.sta === -500) {
            this.handleErr("/normal/detail?qid=" + this.qid);
          } else if (
            res.sta === -1 &&
            (res.errcode === 113 || res.errcode === 110)
          ) {
            this.cancelWatch();
            this.type = 2;
          } else {
            Toast(res.msg);
          }
        })
        .catch(err => {
          this.cancelWatch();
        });
    },
    quesStart() {
      questionOnly
        .post("/xcx/ques/v2/start", {
          access_token: getToken(),
          qid: this.qid,
          version_code: 1
        })
        .then(res => {
          if (res.sta == 0) {
            let { info = {} } = this;
            let { enable_time_range = 0, t_end = 0 } = info;
            if (enable_time_range && getLocalTime() > t_end * 1000) {
              return this.cancelWatch();
            }
            // 跳转答题 =>
            localStorage.setItem("start_time_" + this.qid, res.data.now);
            this.$router.replace({
              name: "doNormal",
              query: { qid: this.qid }
            });
          } else if (res.sta === -500) {
            this.handleErr("/normal/detail?qid=" + this.qid);
          } else if (
            res.sta == -1 &&
            (res.errcode == 110 || res.errcode == 113)
          ) {
            // 达到答题人数上限
            this.type = 2;
            this.cancelWatch();
          } else {
            Toast(res.msg);
            this.cancelWatch();
          }
        })
        .catch(() => {
          this.cancelWatch();
        });
    },
    updateWait(action_type) {
      questionOnly
        .post("/xcx/ques/v1/wait/update", {
          access_token: getToken(),
          qid: this.qid,
          action_type
        })
        .then(res => {
          if (action_type) {
            localStorage.removeItem("wait" + this.qid);
          }
          if (res.sta === -500) {
            this.handleErr("/normal/detail?qid=" + this.qid);
          }
        });
    },
    handleErr(url = "") {
      if (this.isInApp) {
        localStorage.setItem(
          "qid",
          JSON.stringify({
            qid: this.qid,
            type: 0
          })
        );
      }
      reLogin("qid", url);
    },
    getDetail() {
      return new Promise(resolve => {
        questionOnly
          .get("/xcx/ques/v1/detail/home", {
            access_token: getToken(),
            qid: this.qid,
            version_code: "1"
          })
          .then(res => {
            if (res.sta == 0) {
              res.data.startDate = res.data.t_start
                ? formatDate(
                    new Date(res.data.t_start * 1000),
                    "yyyy-MM-dd HH:mm",
                    "sameYear"
                  )
                : "";
              res.data.endDate = res.data.t_end
                ? formatDate(
                    new Date(res.data.t_end * 1000),
                    "yyyy-MM-dd HH:mm",
                    "sameYear"
                  )
                : "";
              this.info = res.data;

              resolve(res.data);
            } else if (res.sta === -500) {
              this.handleErr("/normal/detail?qid=" + this.qid);
            } else {
              Toast(res.msg);
            }
          });
      });
    }
  },

  destroyed() {
    this.cancelWatch();
  },
  watch: {
    showContact(val) {
      if (val) {
        // 打开客服二维码
        this.watchAble = false;
        if (this.cur_status) {
          // 当前是发卷失败
          if (timer) {
            clearInterval(timer);
            timer = null;
          }
        } else {
          // 当前仍然是排队
          if (timerCount) {
            clearInterval(timerCount);
            timerCount = null;
          }
        }
      } else {
        // 关闭客服二维码
        if (this.cur_status) {
          // 发卷失败
          this.countdownTime();
        } else {
          //排队中
          this.watchAble = true;
          this.watching();
          this.countdownCount();
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@function rem($px) {
  @return $px / 2 + px;
}

.tip {
  text-align: center;
}
.detail-pause {
  text-align: center;
  // padding: rem(30);
  box-sizing: border-box;
  .tip-icon {
    width: rem(160);
    height: rem(160);
    margin-bottom: rem(30);
  }
  .tips {
    font-size: rem(36);
    line-height: rem(54);
  }
  .desc {
    font-size: rem(28);
    line-height: rem(42);
    color: #999999;
    margin-top: rem(10);
  }
  .desc text {
    color: #1890ff;
  }
  .btn-group {
    display: flex;
    position: relative;
    margin-top: rem(60);
  }
  .btn-group button {
    flex: 1;
    height: rem(80);
    line-height: rem(80);
    text-align: center;
    border-radius: rem(8);
    background: #1890ff;
    font-size: rem(30);
    color: #ffffff;
    cursor: pointer;
  }
  .cur-icon {
    width: rem(340);
    height: rem(240);
  }
  .cur_text {
    font-size: rem(28);
    line-height: rem(42);
    color: #999999;
  }
  .cur_text button {
    display: inline;
    font-size: rem(28);
  }
  .backIcon {
    text-align: center;
    margin-top: rem(60);
    display: flex;
    align-items: center;
  }
  .backIcon button {
    flex: 1;
    background-color: #1890ff;
    color: #ffffff;
    height: rem(80);
    line-height: rem(80);
    font-size: rem(30);
    border-radius: rem(4);
    cursor: pointer;
  }
  .mr30 {
    margin-right: rem(30);
  }
}
.ml30 {
  margin-left: rem(30);
}
.upgrage-wrapper {
  padding: 25px;
  font-size: 17px;
  text-align: center;
  color: #262626;
  .upgrage-title {
    line-height: 25px;
    margin-top: 15px;
  }
  .contact-btn {
    height: 43px;
    line-height: 43px;
    text-align: center;
    background: #1890ff;
    color: #fff;
    border-radius: 2px;
    font-size: 16px;
    margin: 20px auto;
  }
  .other-way {
    display: flex;
    color: #999999;
    align-items: center;
    justify-content: space-around;
    font-size: 14px;
    margin-top: 20px;
    div {
      margin: 0 4px;
    }
    p {
      // height: 1px;
      flex: 1;
      border-bottom: 1px dashed #999;
    }
  }
  .quesTitle {
    line-height: 21px;
    font-weight: 700;
    margin: 20px 0 15px;
  }
  .quesQrcode {
    width: 160px;
    height: 160px;
    object-fit: cover;
    margin: 0 auto 15px;
    display: block;
  }
  .upgrag-tip {
    display: inline-block;
    font-size: 14px;
    line-height: 21px;
    border: 1px dashed #ccc;
    padding: 6px 10px;
    color: #999;
  }
}
.pause-box {
  background: #fff;
  padding: 15px;
}
.inline-r {
  display: inline-block;
  position: relative;
}

/* .backIcon button:first-child{
  margin-right: 30);
} */
</style>



// WEBPACK FOOTER //
// src/pages/normal/detailPause.vue